/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Observable } from 'rxjs';
import { PreviewEnvironment } from 'app/shared-data/models';
import { TenantDetails } from 'app/page-modules/tenant-management/models';

export abstract class SharedDataService {
  /** Returns available preview environment data. */
  abstract previewEnvironments(): Observable<PreviewEnvironment[]>;

  /**
   * Returns all the tenants
   * @return the tenant details
   */
  abstract tenants(): Observable<TenantDetails[]>;
}
